import { render, staticRenderFns } from "./EditInterestContactsPage.vue?vue&type=template&id=0c1c4149&scoped=true&"
import script from "./EditInterestContactsPage.vue?vue&type=script&lang=js&"
export * from "./EditInterestContactsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c4149",
  null
  
)

export default component.exports